import { useCallback } from 'react';
import { UseFieldArrayRemove } from 'react-hook-form';

import { ValidationItems } from '@kanda-libs/ks-component-ts';

import useIncomeExpenseValidation from '../../useIncomeExpenseValidation';

export interface IncomeItemHook {
  removeItem: () => void;
  selectValidation: ValidationItems;
  amountValidation: ValidationItems;
}

export default function useIncomeItem(
  index: number,
  remove: UseFieldArrayRemove,
): IncomeItemHook {
  const removeItem = useCallback(() => remove(index), [remove, index]);
  const { selectValidation, amountValidation } = useIncomeExpenseValidation(
    index,
    'income',
  );

  return {
    removeItem,
    selectValidation,
    amountValidation,
  };
}
